import React from 'react'
import styled from 'styled-components/macro'
import { theme } from 'styled-tools'
import {
  ModalBody as ReactstrapModalBody,
  Modal as ReactstrapModal
} from 'reactstrap'
import { MdShare } from 'react-icons/md'
import { media } from 'ui/rwd'
import { CircleIcon as BaseCircleIcon } from 'ui/components/CircleIcons'

const ModalBody = styled(ReactstrapModalBody)`
  border-radius: 0;
  background-color: ${theme('storeBackgroundColor')};
  display: flex;
  position: relative;
`

const ShareCircle = styled(BaseCircleIcon).attrs({
  width: '2.5rem',
  height: '2.5rem'
})`
  z-index: 11;
  border: 0;
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  background: ${theme('white')};
  color: ${theme('black')};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  &:hover {
    background: white;
  }
  ${media.sm`
    top: -45px;
    right: 50px;
  `}
`

const ShareIcon = styled(MdShare)`
  width: 1.5rem
  color: black;
`

const Modal = styled(ReactstrapModal)`
  max-width: 800px !important;
  margin: 0 !important;
  height: 100%;

  ${media.sm`
    margin: 1.75rem auto !important;
    margin-top: 4rem !important;
    height: initial;
  `}

  .modal-content {
    border-radius: 0;
    height: 100%;
    display: block;
    border: none;
    ${media.sm`
      border-radius: 8px;
      display: flex;
      box-shadow: 2px 2px 4px 0 rgba(0,0,0,0.4);
    `}
  }
`

const ShareButtonCircle = ({ ...props }) => (
  <ShareCircle {...props}>
    <ShareIcon />
  </ShareCircle>
)

export { ModalBody, ShareButtonCircle, Modal }
